import { render, staticRenderFns } from "./SVG-Plus.vue?vue&type=template&id=4142c4d6&lang=pug&"
import script from "./SVG-Plus.vue?vue&type=script&lang=js&"
export * from "./SVG-Plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports